import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { request } from "@insite/client-framework/Services/ApiService";

const emailApiBaseUrl = "/api/v2/email";
export interface CustomEmailTemplateParameter extends ApiParameter {
    [key: string]: any;
}

export function sendCustomEmailTemplate(parameter: CustomEmailTemplateParameter) {
    return post<CustomEmailTemplateParameter>(`${emailApiBaseUrl}/FormDataSubmit`, parameter);
}

export function sendFormDataWithAttachment(formData: FormData) {
    return request<any>(
        `${emailApiBaseUrl}/FormDataWithAttachment`,
        "POST",
        undefined,
        formData
    );
}
